import React from 'react';
import { APP_BAR_BOTTOM_HEIGHT, APP_BAR_BOTTOM_Z_INDEX } from '@/styles';
import { Box, boxProps, BoxProps } from '@design-system/mobile';
import styled, { css } from 'styled-components';

export interface AppBarBottomProps extends BoxProps {
  children: React.ReactNode;
  isShow?: boolean;
  noFixed?: boolean;
  zIndex?: number;
}

/**
 * 디자인 시스템 common의 app_bar_bottom 요소
 * @author 이현우
 * @param param0
 * @returns
 */
const AppBarBottom = ({
  isShow,
  children,
  noFixed,
  zIndex = APP_BAR_BOTTOM_Z_INDEX,
  ...props
}: AppBarBottomProps) => {
  return (
    <Layout isShow={isShow} {...props}>
      <Container isShow={isShow} zIndex={zIndex} noFixed={noFixed}>
        {children}
      </Container>
    </Layout>
  );
};

export default AppBarBottom;

const Container = styled.div<{
  isShow?: boolean;
  noFixed?: boolean;
  zIndex?: number;
}>`
  ${({ isShow, theme, noFixed, zIndex }) => css`
    position: fixed;
    bottom: 0;
    left: 0;
    right: 0;
    width: 100%;
    height: ${isShow ? `${APP_BAR_BOTTOM_HEIGHT}px` : '0px'};
    opacity: ${isShow ? 1 : 0};
    ${!noFixed &&
    css`
      z-index: ${zIndex};
    `}

    transition: all 0.3s;
    background: ${theme.colors.color_chip.white};
    border-top: solid 1px ${theme.colors.color_chip.gray['200']};
    display: flex;
    justify-content: space-between;
    align-items: center;
  `}
`;
const Layout = styled(Box).attrs({ as: 'div' })`
  ${({ isShow }) => css`
    padding-bottom: ${isShow ? `${APP_BAR_BOTTOM_HEIGHT}px` : '0px'};
  `}

  ${boxProps}
`;
